import { useSearchParams } from '@direct-frontend/modules-router';

export const useConstructorVersion = () => {
    const [searchParams] = useSearchParams();
    const parsedVersion = Number(searchParams.get('version'));

    return Number.isInteger(parsedVersion) && parsedVersion > 0 ? parsedVersion : undefined;
};
